const shadows = {
  md: "0px 10px 25px rgba(0, 0, 0, 0.08)",
  error: "0 0 0 1px #fd3d3d",
  outline: "0 0 0 2px rgba(255, 189, 41, 0.5)",
  box: "0px 0px 10px rgba(0, 0, 0, 0.08)",
  lg: "0px 10px 50px rgb(0, 0, 0, 0.15)",
};

export default shadows;
